import { ApiFetcher } from "../api/api.fetcher";
import { Picklist } from "../picklist/interfaces/picklist.interface";
import { JobType } from '../../types';

/**
 * 人事情報へのアクセスを提供するサービス
 */
export class RecruitEntryService {
  private impl: any;

  constructor() {
    this.impl = process.env.REACT_APP_SERVICE_MODE === 'MOCK' ?
      new RecruitEntryServiceMock() :
      new RecruitEntryServiceImpl();
  }
  /**
   * 人事情報を登録します。
   * @param recruitEntry 
   */
  async create(recruitEntry: any): Promise<void> {
    await this.impl.create(recruitEntry);
  }

  /**
   * 人事情報に紐づく選択値リストを取得します。
   */
  async getPicklist(): Promise<Picklist[]> {
    return await this.impl.getPicklist();
  }
}

class RecruitEntryServiceImpl {
  private apiFetcher = new ApiFetcher();

  async create(recruitEntry: any): Promise<void> {
    await this.apiFetcher.post('recruit-entry', recruitEntry);
  }
  async getPicklist(): Promise<Picklist[]> {
    const data = this.apiFetcher.get('recruit-entry/meta/picklist');

    return data;
  }
}
class RecruitEntryServiceMock {
  wait = async (timeout: number) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(0);
      }, timeout);
    });
  }
  async create(recruitEntry: any): Promise<void> {
    await this.wait(1000);
  }
  async getPicklist(): Promise<Picklist[]> {
    await this.wait(1000);
    
    return [
      {
        name: 'desiredJobType',
        values: [
          {label:'靴職人', value: JobType.MeisterShoes},
          {label:'鞄職人', value: JobType.MeisterBags},
          {label:'販売職', value: JobType.ClientAdvisor},
          {label:'エンジニア職', value: JobType.ITEngineer},
        ],
      } as Picklist,
      {
        name: 'gender',
        values: [
          {label:'男性', value:'male'},
          {label:'女性', value:'female'},
        ],
      } as Picklist,
      {
        name: 'howToKnow',
        values: [
          {label:'SNS', value:'sns'},
        ],
      } as Picklist,
    ];
  }
}